import { render, staticRenderFns } from "./realOrderList.vue?vue&type=template&id=e1e7a22c&scoped=true&"
import script from "./realOrderList.vue?vue&type=script&lang=js&"
export * from "./realOrderList.vue?vue&type=script&lang=js&"
import style0 from "./realOrderList.vue?vue&type=style&index=0&id=e1e7a22c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1e7a22c",
  null
  
)

export default component.exports